<!--
 * @Description:分配客户负责人组件
 * @Author: mdb
 * @Date: 2022-07-13 16:10:45
 * @LastEditTime: 2022-12-01 13:58:28
 * @LastEditors: mdb
-->
<template>
  <a-modal
    v-model:visible="visible"
    title="分配负责人"
    :body-style="{ padding: '30px' }"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }">
      <a-form-item label="客户负责人" v-bind="validateInfos.follower">
        <UserSelect v-model:value="dataForm.follower" :status="1" placeholder="请选择" allowClear />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueAllot } from '@/api/gucangSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ follower: string; clueIdList: any[] }>({ follower: '', clueIdList: [] })
const formRules = reactive({
  follower: [{ required: true, message: '请选择客户负责人' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.clueIdList = selectedData.value.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueAllot(params)
      .then(() => {
        emit('fetch', dataForm.follower)
        DcMessage.success('分配客户负责人成功')
        resetFields()
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ClueAssign' }
</script>

<style scoped></style>
